import smoothscroll from "smoothscroll-polyfill"

export default function initSmoothScroll() {
  smoothscroll.polyfill()
}
